import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import 'es6-promise/auto'
import axios from 'axios'
import vDialogs from 'v-dialogs'
import VueYoutube from 'vue-youtube'
import VueTelInput from 'vue-tel-input'

Vue.use(VueYoutube)
Vue.use(vDialogs, { language: 'en' })
Vue.use(VueTelInput)
Vue.config.productionTip = false


import VueElementLoading from 'vue-element-loading'
import ServerError from './components/Popup/500'
Vue.component('VueElementLoading', VueElementLoading)
Vue.component('ServerError', ServerError)


var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
window.axios = require('axios')

// axios.defaults.headers.Common['x-auth-token'] = localStorage.getItem('token')
Vue.prototype.baseURL = 'http://43.205.144.230'; // URL for File retriving Globaly initialized

axios.defaults.baseURL = 'http://43.205.144.230'; // Production URL
// axios.defaults.baseURL = 'http://localhost:3000';
axios.defaults.timeout = 120000;

new Vue({
  vuetify,
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')
